// pages/FormViewerPage/sections/orderSummary/PriceRows.tsx — Rincian harga pesanan
import React from 'react';
import { CouponCodeInput } from '../CouponCodeInput';
import { formatMoney } from '../../../../utils/formatMoney';
import { singleLockGroup } from '../../../../utils/regionPricing';
import { ms } from '../../../../locales/ms';

export const PriceRows: React.FC<{
    hook: any;
    subtotal: number;
    shippingLabel: React.ReactNode;
    isSimpleBayar: boolean;
    hideDetails: boolean;
}> = ({ hook, subtotal, shippingLabel, isSimpleBayar, hideDetails }) => {
    const { form, shippingCost, codFee, currentCombination, quantity, discountAmount, couponApplied, addressData, bumpSum, bumpDiscount } = hook;
    if (hideDetails) return null;
    const rp = (n: number) => formatMoney(n, form);
    // Mode region: harga ikut provinsi — sembunyikan angka sebelum provinsi dipilih.
    // Kunci 1 grup jelas → tampil langsung (tak perlu tunggu provinsi).
    const needProvince = (form.productRegionGroups?.length || 0) > 0 && !singleLockGroup(form) && !addressData?.province;
    const pending = <span className="text-sm font-normal text-slate-400 dark:text-slate-500">–</span>;

    return (
        <>
            <div className="flex justify-between items-baseline text-sm">
                <span className="text-slate-500 dark:text-slate-300">{ms(form, m => m.subtotal, 'Subtotal')}</span>
                <div className="flex items-baseline gap-2">{needProvince ? pending : <>{!!currentCombination?.strikethroughPrice && currentCombination.strikethroughPrice > subtotal && <span className="text-slate-500 dark:text-slate-400 line-through">{rp(currentCombination.strikethroughPrice * quantity)}</span>}<span className="font-medium">{rp(subtotal * quantity)}</span></>}</div>
            </div>
            {Number(bumpSum) > 0 && (
                <div className="flex justify-between text-sm">
                    <span className="text-slate-500 dark:text-slate-300">Produk Tambahan</span>
                    <span className="font-medium">+ {rp(Number(bumpSum))}{Number(bumpDiscount) > 0 && <span className="ml-1.5 text-[10px] text-emerald-600">Hemat {rp(Number(bumpDiscount))}</span>}</span>
                </div>
            )}
            <div className="flex justify-between text-sm"><span className="text-slate-500 dark:text-slate-300">{ms(form, m => m.shipping, 'Pengiriman')}</span><span className="font-medium text-right">{shippingLabel}</span></div>
            {isSimpleBayar && (
                <p className="text-xs text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-2">
                    Harga total belum termasuk ongkir. Info ongkir akan disampaikan oleh Customer Service setelah pesanan dikonfirmasi.
                </p>
            )}
            {codFee > 0 && <div className="flex justify-between text-sm"><span className="text-slate-500 dark:text-slate-300">Biaya Penanganan COD</span><span className="font-medium">{needProvince ? pending : rp(codFee)}</span></div>}
            {form.couponEnabled && (
                <div className="pt-1"><CouponCodeInput hook={hook} /></div>
            )}
            {discountAmount > 0 && (
                <div className="flex justify-between text-sm">
                    <span className="text-slate-500 dark:text-slate-300">{ms(form, m => m.discount, 'Diskon')}{couponApplied?.code ? ` (${couponApplied.code})` : ''}</span>
                    <span className="font-medium text-emerald-600 dark:text-emerald-400">− {rp(discountAmount as number)}</span>
                </div>
            )}
            <div className="flex justify-between font-bold text-lg text-slate-900 dark:text-slate-100"><span>{ms(form, m => m.totalPay, 'Total')}</span><span>{needProvince ? pending : rp((subtotal * quantity) + (Number(bumpSum) || 0) + shippingCost + codFee - (discountAmount || 0))}</span></div>
        </>
    );
};
